// routes
import { paths } from 'src/routes/paths';

// API
// ----------------------------------------------------------------------

export const HOST_API = process.env.REACT_APP_HOST_API;
export const ASSETS_API = process.env.REACT_APP_ASSETS_API;

export const FIREBASE_API = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const AMPLIFY_API = {
  userPoolId: process.env.REACT_APP_AWS_AMPLIFY_USER_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_AWS_AMPLIFY_USER_POOL_WEB_CLIENT_ID,
  region: process.env.REACT_APP_AWS_AMPLIFY_REGION,
};

export const AUTH0_API = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
  callbackUrl: process.env.REACT_APP_AUTH0_CALLBACK_URL,
};

export const MAPBOX_API = process.env.REACT_APP_MAPBOX_API;

// POSTHOG
// ----------------------------------------------------------------------

export const POSTHOG_KEY = process.env.REACT_APP_POSTHOG_KEY;
export const POSTHOG_HOST = process.env.REACT_APP_POSTHOG_HOST;
// PostHog runs only on the production hosts. Set to 'true' to force it on
// elsewhere (e.g. to test tracking locally), or 'false' to force it off.
export const POSTHOG_ENABLED = process.env.REACT_APP_POSTHOG_ENABLED;

// MICROSOFT SIGN-IN
// ----------------------------------------------------------------------

// The FVSD Azure AD tenant, the authority for the single-tenant sign-in apps.
export const AZURE_FVSD_AUTHORITY = 'https://login.microsoftonline.com/42242eff-faf6-4ccd-aea3-e2c4479f8ccb';

// Client ID of the staff sign-in app. Set per environment (dev has its own
// "MyFVSD Staff Login (Dev)" app); unset, it is the production app.
export const AZURE_STAFF_CLIENT_ID =
  process.env.REACT_APP_AZURE_STAFF_CLIENT_ID || '88b6bf8b-3a50-4e61-adc6-6edfbd904c6d';

// Client ID of the "MyFVSD Student Login" app registration (#602). While unset,
// the Student sign in buttons are not shown.
export const AZURE_STUDENT_CLIENT_ID = process.env.REACT_APP_AZURE_STUDENT_CLIENT_ID;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = paths.dashboard;
